import React from "react";
import { useTranslation } from "react-i18next";
import { useFormat } from "../../../../i18n/format";
import "./ProfileModal.css";
import Logout from "@mui/icons-material/ExitToAppRounded";
import RiseModal from "../../../RiseModal/RiseModal";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { IoPersonCircle, IoSettings } from "react-icons/io5";
import { useLogout } from "../../../../hooks/useLogout";

const CarrierProfileModal = ({ onClose, style }) => {
  const user = useSelector((state) => state.user);
  const { t } = useTranslation(["nav", "common"]);
  const { formatMoney } = useFormat();
  const { logout: handleLogout, loggingOut } = useLogout();

  return (
    <RiseModal style={style} onClose={onClose}>
      <div className="profile_modal">
        <div className="profile_modal_title">
          {t("nav:balance", { amount: formatMoney(user.balance) })}
        </div>
        <Link className="profile_modal_item" to="/carrier-profile">
          <IoPersonCircle size={20} className="profile_modal_icon" />
          <div>{t("nav:profile")}</div>
        </Link>
        <Link
          className="profile_modal_item"
          to={"carrier/settings/table-pagination"}
        >
          <IoSettings size={20} className="profile_modal_icon" />
          <div>{t("nav:settings")}</div>
        </Link>

        <hr />
        <div
          className={`profile_modal_item ${
            loggingOut && "profile_modal_itemdisabled"
          }`}
          onClick={handleLogout}
        >
          <Logout className="pm_item_icon" />
          <div className="pm_item_text">{t("common:actions.logout")}</div>
          {!loggingOut && (
            <div className="version__badge">
              {process.env.React_APP_Version}
              <span></span>
            </div>
          )}
          <span className="pm_item_logoutloader">
            {" "}
            {loggingOut && <CircularProgress size={16} />}
          </span>
        </div>
      </div>
    </RiseModal>
  );
};

export default CarrierProfileModal;
